import React from 'react';
import PropTypes from 'prop-types';
import QualifiedPlayersPredictiveSearch from './QualifiedPlayersPredictiveSearch';
import QualifiedPlayersListingFiltersTriggerButton
    from './QualifiedPlayersListingFiltersTriggerButton';
import app, {
    DEVICE_TYPE_MOBILE,
    EVENT_DEVICE_TYPE_CHANGED
} from '../../../general/js/app';
import eventBus from '../../../general/js/event-bus';

export default class QualifiedPlayersListingControls extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isMinimized: this.getIsMinimized(),
            isFocused: false,
            isExpanded: false
        };

        this.onPredictiveSearchBlur = this.onPredictiveSearchBlur.bind(this);
        this.onPredictiveSearchFocus = this.onPredictiveSearchFocus.bind(this);
        this.onCollapseButtonClick = this.onCollapseButtonClick.bind(this);
        this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
        this.inputRef = this.inputRef.bind(this);
    }

    componentDidMount() {
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    inputRef(el) {
        this.inputElement = el;
    }

    onDeviceTypeChanged = () => {
        const newState = {
            isMinimized: this.getIsMinimized(),
        };

        if (newState.isMinimized !== this.state.isMinimized) {
            newState.isExpanded = false;
        }
        this.setState(newState);
    }

    onPredictiveSearchBlur() {
        const newState = {
            isFocused: false
        };
        if (this.state.isMinimized && this.props.isFiltersApplied && this.state.isExpanded) {
            newState.isExpanded = false;
        }
        this.setState(newState);
    }

    onPredictiveSearchFocus() {
        const newState = {
            isFocused: true
        };
        if (this.state.isMinimized && !this.state.isExpanded) {
            newState.isExpanded = true;
        }
        this.setState(newState);
    }

    onCollapseButtonClick() {
        this.setState({ isExpanded: false });
    }

    onSearchButtonClick(e) {
        const isMinimized = this.state.isMinimized;
        const isExpanded = this.state.isExpanded;

        if (isMinimized && !isExpanded) {
            e.preventDefault();
            this.setState({ isExpanded: true });
            this.inputElement.focus();
        }
    }

    getIsMinimized() {
        return app.deviceTypeByViewport === DEVICE_TYPE_MOBILE;
    }

    isTriggerButtonVisible() {
        return !this.state.isMinimized || !this.state.isExpanded;
    }

    render() {
        return (
            <div className="qualified-players-listing__controls">
                <div className="container">
                    <div className="qualified-players-listing__controls-inner">
                        {this.isTriggerButtonVisible() ?
                            <QualifiedPlayersListingFiltersTriggerButton
                                onClick={this.props.onFiltersTogglerClick}
                                isFiltersVisible={this.props.isFiltersVisible}/> : null}
                        <div className="qualified-players-listing__predictive-search">
                            <QualifiedPlayersPredictiveSearch
                                inputRef={this.inputRef}
                                filters={this.props.filters}
                                isFiltersApplied={this.props.isFiltersApplied}
                                onFiltersChange={this.props.onFiltersChange}
                                endpointUrl={this.props.options.predictiveEndpointUrl}
                                isMinimized={this.state.isMinimized}
                                isFocused={this.state.isFocused}
                                isExpanded={this.state.isExpanded}
                                onBlur={this.onPredictiveSearchBlur}
                                onFocus={this.onPredictiveSearchFocus}
                                onCollapseButtonClick={this.onCollapseButtonClick}
                                onSearchButtonClick={this.onSearchButtonClick}
                                maxSuggestionsCount={20}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

QualifiedPlayersListingControls.propTypes = {
    onFiltersChange: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    isFiltersApplied: PropTypes.bool.isRequired,
    isFiltersVisible: PropTypes.bool.isRequired,
    options: PropTypes.object,
    onFiltersTogglerClick: PropTypes.func.isRequired,
};
